


























import {Vue, Component} from 'vue-property-decorator'

import BaseModal from '@/pages/common/BaseModal.vue'
import {Warning} from '@/icons'

@Component({
  components: {
    BaseModal,
    Warning,
  }
})
export default class DuplicationModal extends Vue {
}
